var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#6DD664"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5156 11.2124H6.40137V9.95557H10.478C10.811 9.95557 11.076 9.90365 11.2729 9.7998C11.4735 9.69596 11.6185 9.55273 11.708 9.37012C11.7975 9.18392 11.8423 8.97266 11.8423 8.73633C11.8423 8.50358 11.7939 8.29053 11.6973 8.09717C11.6042 7.90023 11.4591 7.74268 11.2622 7.62451C11.0688 7.50277 10.8218 7.44189 10.521 7.44189H9.09766V14H7.48633V6.17969H10.5156C11.1315 6.17969 11.6579 6.2889 12.0947 6.50732C12.5352 6.72575 12.8735 7.02653 13.1099 7.40967C13.3462 7.79281 13.4644 8.23145 13.4644 8.72559C13.4644 9.24479 13.3426 9.69059 13.0991 10.063C12.8592 10.4354 12.519 10.7201 12.0786 10.917C11.6418 11.1139 11.1208 11.2124 10.5156 11.2124ZM10.811 11.6528V12.9097H6.40137V11.6528H10.811Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRub);
export default __webpack_public_path__ + "static/media/rub.24baeaca8526fea6e26ebef77697aa1a.svg";
export { ForwardRef as ReactComponent };